const DetailsReducer = (state='',action)=>{
    if(action.type==='DETAILS'){
        return {id:action.id,isMovie:action.isMovie};
    }
    return state;
}

export default DetailsReducer;